import { render, staticRenderFns } from "./TransactionCurrency.vue?vue&type=template&id=55cab378&scoped=true&"
import script from "./TransactionCurrency.vue?vue&type=script&lang=js&"
export * from "./TransactionCurrency.vue?vue&type=script&lang=js&"
import style0 from "./TransactionCurrency.vue?vue&type=style&index=0&id=55cab378&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cab378",
  null
  
)

export default component.exports